module.exports = __webpack_public_path__ + "static/media/fb.cd1a46cc.svg";